import { createActions } from 'redux-actions'

const View = createActions({ },
  'SET_FULLSCREEN_ON',
  'SET_FULLSCREEN_OFF'
)

export default View
